import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Loader2, Upload, Image } from 'lucide-react';
import { AppleWalletPreview } from './AppleWalletPreview';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BackgroundTab = ({ formData, setFormData, isNew, id, uploading, setUploading, setError, getLogoUrl }) => (
  <div className="grid lg:grid-cols-[1fr,480px] gap-8">
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Image className="w-5 h-5" />
          Bannière de la carte
        </CardTitle>
        <p className="text-sm text-slate-500">Cette image apparaît comme visuel principal sur votre carte Apple Wallet. Recommandé : 1125 x 432 pixels (PNG ou JPG).</p>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Current banner preview */}
        {(formData.strip_url || formData.background_url) && formData.background_url !== 'gradient' ? (
          <div className="space-y-3">
            <div className="relative rounded-xl overflow-hidden border border-slate-200" style={{ aspectRatio: '1125/432' }}>
              <img
                src={getLogoUrl(formData.strip_url || formData.background_url)}
                alt="Banner"
                className="w-full h-full object-cover"
              />
              <button
                type="button"
                onClick={async () => {
                  setFormData({ ...formData, strip_url: '', background_url: '' });
                  if (!isNew) {
                    try {
                      await axios.put(`${API_URL}/api/cards/${id}`, { strip_url: '', background_url: '' }, { withCredentials: true });
                    } catch (e) { console.error(e); }
                  }
                }}
                className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold hover:bg-red-600 shadow-lg"
              >
                x
              </button>
            </div>
            <p className="text-xs text-green-600 font-medium">Custom banner active</p>
          </div>
        ) : (
          <div
            className="rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center p-8 text-center"
            style={{ aspectRatio: '1125/432' }}
          >
            <Upload className="w-10 h-10 text-slate-300 mb-3" />
            <p className="text-sm font-medium text-slate-600 mb-1">Aucune bannière</p>
            <p className="text-xs text-slate-400 mb-4">Un dégradé sera généré automatiquement à partir de la couleur de votre carte</p>
          </div>
        )}

        {/* Upload button */}
        <div className="relative">
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp"
            className="absolute inset-0 opacity-0 cursor-pointer z-10"
            data-testid="background-upload-input"
            disabled={isNew || uploading}
            onChange={async (e) => {
              const file = e.target.files[0];
              if (!file) return;
              setUploading(true);
              try {
                const fd = new FormData();
                fd.append('file', file);
                const { data } = await axios.post(`${API_URL}/api/upload`, fd, { withCredentials: true });
                setFormData(prev => ({ ...prev, strip_url: data.url, background_url: data.url }));
                if (!isNew) {
                  await axios.put(`${API_URL}/api/cards/${id}`, { strip_url: data.url, background_url: data.url }, { withCredentials: true });
                }
              } catch (err) {
                setError('Échec de l\'import');
              } finally {
                setUploading(false);
              }
            }}
          />
          <Button variant="outline" className="w-full h-12" type="button" disabled={isNew || uploading}>
            {uploading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Upload className="w-4 h-4 mr-2" />}
            {formData.strip_url || formData.background_url ? 'Remplacer la bannière' : 'Importer une bannière'}
          </Button>
        </div>

        {isNew && (
          <p className="text-xs text-orange-600">Enregistrez la carte d'abord pour importer une image</p>
        )}

        <div className="p-4 bg-slate-50 rounded-lg text-sm text-slate-600 space-y-1">
          <p className="font-medium text-slate-700">Recommandations</p>
          <p>Taille : <strong>1125 x 432 px</strong></p>
          <p>Format : PNG ou JPG</p>
          <p>Cette image est le visuel principal de votre carte Apple Wallet (zone strip)</p>
        </div>
      </CardContent>
    </Card>

    {/* Preview sticky + 20% (point 5) */}
    <div className="lg:sticky lg:top-5 self-start">
      <Card className="border-slate-200">
        <CardHeader>
          <CardTitle>Aperçu Apple Wallet</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="transform scale-[1.05] origin-top">
            <AppleWalletPreview formData={formData} getLogoUrl={getLogoUrl} variant="full" />
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);

